import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const orderListRange = (startDate, endDate) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "order_List_range_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.orderlistrange}`, // Update API endpoint as needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
          startDate: startDate,
          endDate: endDate,
          //status_id: 1
        },
      }
    );
    dispatch({ type: "order_List_range_Success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "order_List_range_failure",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const orderList = (page=1,startDate = null, endDate = null) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();
  dispatch({ type: "order_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.orderlist}${user_profile_id}`, // Update API endpoint as needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
          startDate: startDate ? startDate : undefined,
          endDate: endDate ? endDate : undefined,
          page

        },
      }
    );
    dispatch({ type: "order_List_Success", payload: response?.data });
  } catch (error) {
    dispatch({
      type: "order_List_failure",
      payload: error?.response?.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const deleteOrder = (order_id) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "order_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.deleteOrderList}${order_id}`, // Update API endpoint as needed
      {
        sys_ord_active_yn: "N", // Make sure this field matches your backend expectation
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "order_delete_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};

export const grabOrder = (order_id) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "order_req_grab" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.deleteOrderList}${order_id}`, // Update API endpoint as needed
      {
        ord_manager_profile_id: user_profile_id, // Make sure this field matches your backend expectation
        sys_user_id: user_profile_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "order_grab_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};

export const resendOrder =
  (order_id, sendToCustomer, sendToProvider, sendToPatient) =>
  async (dispatch) => {
    const { token, role_id, user_profile_id } = getSession();
    dispatch({ type: "order_req_resend" });
    try {
      const response = await axios.post(
        `${BaseUrl}${Apis.resendorder}${order_id}`, // Update API endpoint as needed
        {
          sys_user_id: user_profile_id,
          role_id: role_id,
          sendToCustomer,
          sendToProvider,
          sendToPatient,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.usr.message);
    } catch (error) {
      toast.error(
        `${
          error.response?.data?.usr?.message ||
          error.response?.data?.message ||
          error.response?.message ||
          error.message
        }`
      );
      dispatch({
        type: "order_resend_failure",
        payload: error.response.data,
      });
    }
  };

export const cancelOrder = (order_id) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  dispatch({ type: "order_req_cancel" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateorder}${order_id}`, // Update API endpoint as needed
      {
        order_status_id: 10, //cancel order
        role_id: role_id,
        sys_user_id: user_profile_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    //dispatch({ type: "order_cancel", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "order_cancel_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};
export const editOrderPrice =
  (order_id, amount, inputValue) => async (dispatch) => {
    const { token, role_id, user_profile_id } = getSession();

    dispatch({ type: "order_req_cancel" });
    try {
      const response = await axios.put(
        `${BaseUrl}${Apis.updateorder}${order_id}`, // Update API endpoint as needed
        {
          order_tot_amt: amount, //cancel order
          role_id: role_id,
          sys_user_id: user_profile_id,
          order_ship_instructions: inputValue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //dispatch({ type: "order_cancel", payload: response.data });
      toast.success(response.data.usr.message);
    } catch (error) {
      dispatch({
        type: "order_cancel_failure",
        payload: error.response.data,
      });

      toast.error(
        `${
          error.response?.data?.usr?.message ||
          error.response?.data?.message ||
          error.response?.message ||
          error.message
        }`
      );
    }
  };
export const rescheduleOrder = (order_id, date, time) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();

  dispatch({ type: "order_req_cancel" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateorder}${order_id}`, // Update API endpoint as needed
      {
        ord_svc_date: date,
        ord_svc_time: time,
        role_id: role_id,
        sys_user_id: user_profile_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    //dispatch({ type: "order_cancel", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "order_cancel_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};

export const createOrder = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_order_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newOrder}`, values, {
      // Update API endpoint as needed
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_order_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_order_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const rateOrder = (order_id, svc_rating_num) => async (dispatch) => {
  const { token, role_id, user_profile_id } = getSession();
  //dispatch({ type: "order_req_rate" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateorder}${order_id}`, // Update API endpoint as needed
      {
        svc_rating_num: svc_rating_num, //rate order
        role_id: role_id,
        sys_user_id: user_profile_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    //dispatch({ type: "order_rate" });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "order_rate_failure",
      payload: error.response.data,
    });

    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};
export const editOrder = (values, orderId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_order_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.newOrder}/${orderId}`, // Update API endpoint as needed
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_order_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_order_failure",
      payload: error.response.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

export const setCurrentData = (data) => (dispatch) => {
  dispatch({ type: "set_order_details", payload: data });
};
export const fetchStatuses = () => async (dispatch) => {
  const { token } = getSession();
  dispatch({ type: "statuses_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.statuses}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "refList_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "statuses_failure",
      payload: error.response.data,
    });
  }
};
